import PracticeLocation from './PracticeLocation.js';

export default PracticeLocation;



// WEBPACK FOOTER //
// ./src/components/Pages/Home/PracticeLocation/index.js